module.exports = __webpack_public_path__ + "HP_Latex_1000-2000_box_printing.jpg?68bed370f142521828e886690ec0832c";